import React from 'react';
import axios from 'axios';
import { Alert, Row, Col, Input, Table, Icon, Divider } from 'antd';

import apiPath from 'apiPath';
import moment from 'components/momentWithZone';
import TransactionTable from 'components/TransactionTable';
import PaymentTriggerForm from 'components/PaymentTriggerForm';
import SaveButton from 'components/SaveButton'
import FinancialNote from './FinancialNote';

export default class FeePayment extends React.Component {
	state = {
		amount: null,
		chargeTotal: null,
		creditTotal: null,
		bookingID: null,
		deferredDepartments: [],
		selectedIncentives: [],
	}

	preCheckout = () => {
		return new Promise((resolve, reject) => {
			if (!isNaN(this.refs.amount.value) && this.refs.amount.value > 0) {
				resolve();
			} else {
				reject({ message: 'Invalid payment amount' });
			}
		});
	}
	getBalance = (props) => {
		if (props.bookingLoaded) {
			this.setState({
				chargeTotal: props.tuitionChargeTotal,
				creditTotal: props.tuitionCreditTotal
			});
		}
	}
	getDeferredTypes = () => {
		axios.get(apiPath + '/financialaid/types').then(result => {
			this.setState({
				deferredDepartments: result.data
					.filter(type => type.category === 'DEFER')
					.map(type => type.departmentId)
			});
		});
	}
	getIncentiveChoice = () => {
		axios.get(apiPath + '/deposit/loadSelectedIncentive', { withCredentials: true }).then(result => {
			this.setState({
				selectedIncentives: result.data
			});
		});
	}
	formatDollarAmount = (amount) => parseFloat(Math.round((amount) * 100) / 100).toFixed(2)
	componentDidMount() {
		this.getBalance(this.props);
		this.getDeferredTypes();
		this.getIncentiveChoice();
	}
	componentWillReceiveProps(nextProps) { this.getBalance(nextProps); }
	render() {
		const disabled = this.props.variant !== 'admin' && !this.props.sectionIsEnabled(this.props, 'financial/programfeepayment');
		if (this.props.variant !== 'admin' && this.props.redirectIfHidden) {
			const redirect = this.props.redirectIfHidden(this.props, 'financial/programfeepayment');
			if (redirect) return redirect;
		}
		const rule = this.props.configRules && this.props.configRules.find(rule => rule.section === 'financial/programfeepayment');
		const beforeEnabled =
			(this.props.variant === 'admin') ? false :
				(!rule) ? true :
					(rule.enableAlways === "1") ? false :
						moment().isBefore(moment.utc(rule.enableFrom));
		const deadlinePassed =
			(this.props.variant === 'admin') ? false :
				(!rule) ? false :
					(rule.enableAlways === "1") ? false :
						moment().isAfter(moment.utc(rule.disableAfter));
		const temporarilyDisabled = false;
		const overrideDisabled = this.props.folio && this.props.folio.FolioId === '115'; // Sue Test

		let { chargeTotal, creditTotal } = this.state;
		let amount = this.state.amount || 0;
		if (amount > chargeTotal - creditTotal) amount = chargeTotal - creditTotal;

		const deferredTransactions = this.props.tuitionPayments
			.filter(t => this.state.deferredDepartments.indexOf(t.DepartmentId) !== -1)
			.map(t => { t.Payment = t.Amount; return t; })
			.sort((a, b) => a.id - b.id);
		const deferredTotal = deferredTransactions.map(t => parseFloat(t.Amount)).reduce((acc, val) => acc + val, 0);

		const tuitionTransactions = this.props.tuitionTransactions
			.map(t => { t.Charge = t.Amount; return t; })
			.concat(
				this.props.tuitionPayments
					.filter(t => this.state.deferredDepartments.indexOf(t.DepartmentId) === -1)
					.map(p => { p.Payment = p.Amount; return p; })
			)
			.filter(t => t.Amount !== '.0000')
			.sort((a, b) => a.id - b.id);
		
		const finalPayment38 = this.props.booking.EventId == 38
		const finalPayment40 = this.props.booking.EventId == 40

		return (
			<div>
				{finalPayment38 &&
				<div>
				<Alert showIcon type="info"
					description={<span><h2 style={{color: "red"}}>FA19 Final Payment Deadline : June 11th, 2019</h2><br /> <p> Full payment or the financial aid notification form which indicates pending home school aid, must be received by this date.</p></span>} />
				<br />
				</div>
				}


				{finalPayment40 &&
				<div>
				<Alert showIcon type="info"
					description={<span><h2 style={{color: "red"}}>SP20 Final Payment Deadline : October 11th, 2019</h2><br /> <p> Full payment or the financial aid notification form which indicates pending home school aid, must be received by this date.</p></span>} />
				<br />
				</div>
				}

				<Alert showIcon type="info"
					message="Notice"
				description={<span>"Payment options include: check (payable in U.S. funds, mailed to Semester at Sea), E-check (enter checking account details below) or credit / debit card (enter Visa, Mastercard, Discover, American Express info below.) The below charges reflect all SAS program fees including: tuition, room, board, Field Classes, premium travel health insurance, and email account. Program charges do not include ancillary charges such as: on-board services, optional Field Programs, fuel surcharges, etc. We make every effort to minimize the impact on our budget of higher fuel prices, but quite often we must assess fuel surcharges to help offset excess fuel costs incurred as a result of volatile market conditions.</span>} />
				<br />
				
				{this.state.selectedIncentives.length > 0 &&
					<div>
					<Alert showIcon type="success"
						message={<a href="https://info.semesteratsea.org/deposit-gift-terms" target="_blank">Early Deposit Gift Selection</a>}
						description={
							<div>
								{
									this.state.selectedIncentives.map(function(incentive){
									return (<p>{incentive.my_voyage_text}</p>);
									})
								}
							</div>
						} />
					<br />
					</div>
				}
				{this.props.bookingLoaded && chargeTotal === creditTotal && creditTotal !== null &&
					<Alert showIcon type="success"
						message="You're all set"
						description="Looks like all of your tuition and fees have been paid" />
				}
				{chargeTotal < creditTotal &&
					<Alert showIcon type="success"
						message="You have credit on your account"
						description={'Your balance is $' + this.formatDollarAmount(creditTotal - chargeTotal)} />
				}
				{chargeTotal > creditTotal && !beforeEnabled && !deadlinePassed && (!temporarilyDisabled || overrideDisabled) &&
					<Alert showIcon type="warning"
						message={'You owe $' + this.formatDollarAmount(chargeTotal - creditTotal) + ' toward tuition and fees'}
						description={
							<div>
								<input type="hidden" ref="amount" name="amount" value={parseFloat(Math.round(amount * 100) / 100).toFixed(2)} />
								<Input
									prefix="$"
									type="number"
									onChange={(e) => this.setState({ amount: e.target.value })}
									onBlur={(e) => {
										if (!isNaN(parseFloat(Math.round(amount * 100) / 100).toFixed(2))) {
											e.target.value = parseFloat(Math.round(amount * 100) / 100).toFixed(2)
										}
									}}
									defaultValue={parseFloat(Math.round(amount * 100) / 100).toFixed(2)} />
								<PaymentTriggerForm showIcon
									variant={this.props.variant}
									kickSession={this.props.kickSession}
									buttonText="Make a Payment"
									orderno_prefix="PRO"
									preCheckout={this.preCheckout}
									refreshBooking={this.props.refreshBooking}
									cust_id={this.props.folio.RepeaterNo}
									booking={this.props.bookingLoaded && this.props.booking}
									client_email={this.props.folio.Email1}
									total={amount} />
							</div>
						} />
				}
				{chargeTotal > creditTotal && (deadlinePassed || beforeEnabled || temporarilyDisabled) &&
					<Alert showIcon type="warning"
						message={'You owe $' + this.formatDollarAmount(chargeTotal - creditTotal) + ' toward tuition and fees'}
						description={(temporarilyDisabled) ? 'Online payments are temporarily disabled, please check back after noon (MT) on July 10' : 'Online payments cannot be made at this time'} />
				}
				<br />
				<TransactionTable
					noNames
					variant={this.props.variant}
					chargeTotal={chargeTotal}
					creditTotal={creditTotal - deferredTotal}
					transactions={tuitionTransactions} />
				{this.props.isStudent && deferredTotal > 0 &&
					<div>
						<br />
						<h3>Deferred Aid</h3>
						<TransactionTable
							noNames
							variant={this.props.variant}
							dueText="Due Now"
							chargeTotal={chargeTotal}
							creditTotal={creditTotal}
							transactions={deferredTransactions} />
					</div>
				}

				<br />

				{this.props.variant == 'admin' &&
					<FinancialNote />
				}

			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./portal-components/Portal/Financial/FeePayment.jsx